/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { NotFoundComponent } from '@/ui/templates';
import AdminPreview from '@/pages/Preview/AdminPreview';
import { useSearch } from '@tanstack/react-router';
import ClientPreview from '@/pages/Preview/ClientPreview';
import { TaxGuideContextProvider } from '@/state/TaxGuideProvider';

/* URL formed locally - http://localhost:3000/preview?companyId=2234&countryId=ar&planId=1381&directLoginId=3159 */

export const Route = createFileRoute('/preview/')({
  loader: ({ params }) => {
    console.log(params);
  },
  component: () => {
    //@ts-ignore
    const search = useSearch({ strict: false });
    const { companyId, countryId, planId, stateId, type } = search as {
      companyId: string;
      countryId: string;
      planId: string;
      stateId: string;
      type: 'client';
    };
    if (!companyId) return <NotFoundComponent />;

    if (type === 'client') {
      return (
        <TaxGuideContextProvider
          companyId={companyId}
          templateType={'clientPreview'}
          language={'en'}
        >
          <ClientPreview country={countryId} plan={planId} state={stateId} />
        </TaxGuideContextProvider>
      );
    } else {
      return (
        <AdminPreview
          companyId={companyId}
          country={countryId}
          plan={planId}
          state={stateId}
        />
      );
    }
  },
});
